import { Typography, Box, TextField } from '@mui/material';
import React from 'react';

import { FeedbackQuestion, QuestionType } from '../../../../types';
import NPSRating from './nps-rating/nps-rating';

interface QuestionFormProps {
  question: FeedbackQuestion;
  value: any;
  onChange: (questionId: number, value: any) => void;
  error?: boolean;
}

export default function QuestionForm({
  question,
  value,
  onChange,
  error = false,
}: QuestionFormProps) {
  const { questionText, questionType, isRequired, id } = question;

  return (
    <Box sx={{ width: '100%' }}>
      <Typography
        variant="h6"
        component="h2"
        sx={{
          mb: 2,
          color: 'white',
          fontWeight: 500,
          display: 'flex',
          alignItems: 'center',
          gap: 0.5,
        }}
      >
        {questionText}
        {isRequired && (
          <Box
            component="span"
            sx={{
              color: error ? 'error.main' : 'rgba(255, 100, 100, 0.8)',
              ml: 0.5,
            }}
          >
            *
          </Box>
        )}
      </Typography>

      {questionType === QuestionType.TEXT && (
        <TextField
          fullWidth
          multiline
          rows={3}
          value={value || ''}
          onChange={(e) => onChange(id, e.target.value)}
          required={isRequired}
          error={error}
          variant="outlined"
          placeholder="Type your answer here..."
          sx={{
            '& .MuiOutlinedInput-root': {
              backgroundColor: 'rgba(255, 255, 255, 0.08)',
              borderRadius: 1.5,
              '& fieldset': {
                borderColor: error ? 'error.main' : 'rgba(255, 255, 255, 0.2)',
              },
              '&:hover fieldset': {
                borderColor: error ? 'error.main' : 'rgba(255, 255, 255, 0.3)',
              },
              '&.Mui-focused fieldset': {
                borderColor: error ? 'error.main' : 'primary.main',
              },
            },
            '& .MuiInputBase-input': {
              color: 'white',
            },
            '& .MuiFormLabel-root': {
              color: 'rgba(255, 255, 255, 0.7)',
            },
          }}
        />
      )}

      {questionType === QuestionType.RATING && (
        <NPSRating
          value={value || 0}
          onChange={(val) => onChange(id, val)}
          required={isRequired}
          useEmoji
        />
      )}

      {questionType === QuestionType.NPS && (
        <NPSRating
          value={value || 0}
          onChange={(val) => onChange(id, val)}
          required={isRequired}
          useEmoji={false}
          max={10}
        />
      )}
    </Box>
  );
}
